// The active editor owns the prompt; the router owns history restoration.
type Blocker = (proceed: () => void) => void;
let blocker: Blocker | null = null;
export function registerNavigationBlocker(value: Blocker) {
  blocker = value;
  return () => {
    if (blocker === value) blocker = null;
  };
}
export function hasNavigationBlocker() {
  return blocker !== null;
}
export function requestNavigation(proceed: () => void) {
  if (blocker) blocker(proceed);
  else proceed();
}
